import { render, staticRenderFns } from "./ShowDetails.vue?vue&type=template&id=0d856fce&scoped=true"
import script from "./ShowDetails.vue?vue&type=script&lang=js"
export * from "./ShowDetails.vue?vue&type=script&lang=js"
import style0 from "./ShowDetails.vue?vue&type=style&index=0&id=0d856fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d856fce",
  null
  
)

export default component.exports